import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import WebSocketPage from './pages/WebSocketPage';
import WhoWeAre from './pages/WhoWeAre';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import EmailVerificationBanner from './components/EmailVerificationBanner';
import WhatsHot from './pages/WhatsHot';
import ArticleDetail from './pages/ArticleDetail';
import ProviderProfile from './pages/ProviderProfile';
import PublicProviderProfile from './pages/PublicProviderProfile';
import Endorsements from './pages/Endorsements';
import SearchResults from './pages/SearchResults';
import CloutWizard from './pages/CloutWizard';
import ProfileWizard from './pages/ProfileWizard';
import WriteReview from './pages/WriteReview';
import AdminReviews from './pages/AdminReviews';
import DashboardLayout from './components/Dashboard/Layout';
import AnalyticsOverview from './pages/Dashboard/Overview';
import AnalyticsSentiment from './pages/Dashboard/Sentiment';
import AnalyticsTopics from './pages/Dashboard/Topics';
import AnalyticsAlerts from './pages/Dashboard/Alerts';
import { getPlatformClasses } from './utils/capacitor';
import './index.css';
import './styles/responsive.css';
import './styles/capacitor.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className={`App ${getPlatformClasses()}`}>
          <EmailVerificationBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/register" element={<Register />} />
            <Route path="/provider/public/:id" element={<PublicProviderProfile />} />
            <Route path="/wizard" element={<CloutWizard />} />
            <Route path="/write-review" element={<WriteReview />} />
            <Route
              path="/admin/reviews"
              element={
                <ProtectedRoute>
                  <AdminReviews />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/websocket"
              element={
                <ProtectedRoute>
                  <WebSocketPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whats-hot"
              element={
                <ProtectedRoute>
                  <WhatsHot />
                </ProtectedRoute>
              }
            />
            <Route
              path="/article/:id"
              element={
                <ProtectedRoute>
                  <ArticleDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/provider/:id"
              element={
                <ProtectedRoute>
                  <ProviderProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProviderProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/endorsements"
              element={
                <ProtectedRoute>
                  <Endorsements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/search"
              element={
                <ProtectedRoute>
                  <SearchResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/complete"
              element={
                <ProtectedRoute>
                  <ProfileWizard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/analytics"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AnalyticsOverview />} />
              <Route path="sentiment" element={<AnalyticsSentiment />} />
              <Route path="topics" element={<AnalyticsTopics />} />
              <Route path="alerts" element={<AnalyticsAlerts />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
